import "@/App.css";
import { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import ServicesIndex from "@/pages/ServicesIndex";
import ServiceDetail from "@/pages/ServiceDetail";
import SpecialIndex from "@/pages/SpecialIndex";
import OurWorks from "@/pages/OurWorks";
import ProjectDetail from "@/pages/ProjectDetail";
import Testimonials from "@/pages/Testimonials";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Contact from "@/pages/Contact";
import LegalPage from "@/pages/LegalPage";
import Sitemap from "@/pages/Sitemap";
import NotFound from "@/pages/NotFound";

// The dashboard — screens, editor and the Firebase Auth session — is one lazy
// chunk. Someone reading the blog never downloads any of it.
const AdminApp = lazy(() => import("@/admin/AdminApp"));

function AdminFallback() {
    return (
        <div className="flex min-h-screen items-center justify-center bg-slate-50 text-sm text-slate-500">
            Loading dashboard…
        </div>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    {/* Public website */}
                    <Route element={<Layout />}>
                        <Route path="/" element={<Home />} />
                        <Route path="/about-us" element={<About />} />
                        <Route path="/services" element={<ServicesIndex />} />
                        <Route path="/services/:slug" element={<ServiceDetail base="services" />} />
                        <Route path="/special-solutions" element={<SpecialIndex />} />
                        <Route
                            path="/special-solutions/:slug"
                            element={<ServiceDetail base="special-solutions" />}
                        />
                        <Route path="/our-works" element={<OurWorks />} />
                        <Route path="/our-works/:slug" element={<ProjectDetail />} />
                        <Route path="/testimonials" element={<Testimonials />} />
                        <Route path="/blog" element={<Blog />} />
                        <Route path="/blog/:slug" element={<BlogPost />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/privacy-policy" element={<LegalPage kind="privacy" />} />
                        <Route path="/terms-of-use" element={<LegalPage kind="terms" />} />
                        <Route path="/sitemap" element={<Sitemap />} />
                        <Route path="*" element={<NotFound />} />
                    </Route>

                    {/* Administrator dashboard */}
                    <Route
                        path="/admin/*"
                        element={
                            <Suspense fallback={<AdminFallback />}>
                                <AdminApp />
                            </Suspense>
                        }
                    />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
